/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetLicensePlateCountryCodes$Params {
}

export function getLicensePlateCountryCodes(http: HttpClient, rootUrl: string, params?: GetLicensePlateCountryCodes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<'A' | 'B' | 'BG' | 'BY' | 'CH' | 'CZ' | 'D' | 'DK' | 'E' | 'F' | 'GB' | 'HR' | 'H' | 'IRL' | 'I' | 'KZ' | 'FL' | 'LT' | 'L' | 'LV' | 'NL' | 'PL' | 'P' | 'RO' | 'RUS' | 'SLO' | 'SK' | 'TR' | 'UA'>>> {
  const rb = new RequestBuilder(rootUrl, getLicensePlateCountryCodes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<'A' | 'B' | 'BG' | 'BY' | 'CH' | 'CZ' | 'D' | 'DK' | 'E' | 'F' | 'GB' | 'HR' | 'H' | 'IRL' | 'I' | 'KZ' | 'FL' | 'LT' | 'L' | 'LV' | 'NL' | 'PL' | 'P' | 'RO' | 'RUS' | 'SLO' | 'SK' | 'TR' | 'UA'>>;
    })
  );
}

getLicensePlateCountryCodes.PATH = '/licenseplatecodes';
